import { API, authClient } from '../index';

// Get all guests
export const getGuests = () => authClient().get(`${API}/guest`);

// Count all guests
export const countGuests = () => authClient().get(`${API}/guest/count?linked=false`);
